module.exports = __webpack_public_path__ + "img/christmashat.53686efa.svg";